import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

export const EditableWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 0 -8px;
  transition: background-color 0.2s;
  cursor: pointer;
  width: 100%;

  &:hover {
    background-color: ${palette.neutral[100]};
  }
`
